import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
   
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0px 1px 0px #E5E5E5',
    boxSizing: 'border-box',
    minHeight: '48px',
    [theme.breakpoints.down('sm')]:{
      flexDirection: 'column',
      minHeight: 'auto',
      }
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '140px',
    height: '100%',
    boxSizing: 'border-box',
    color: '#59758B',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100px',
      alignItems : 'center',
      justifyContent:'center',    
    },
  },
  toolbarTitle: {
    padding: '12px 30px',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '24px',
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      padding: '8px 16px',
      fontSize: '16px',
      textAlign: 'center'
    },
  },
  content: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
       padding: ' 0 20px',
       
    },
  },
  codePanel: {
    padding: '30px',
    minWidth: '420px',
    maxWidth: '450px',
    borderRight: '1px solid #E5E5E5',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100%',
      maxWidth: '100%',
      borderRight: 'none',
      borderBottom: '1px solid #E5E5E5',
    },
  },
  panelTitle: {
    fontSize: '15px',
    fontWeight: 'bold',
    lineHeight: '18px',
  },
  switchers: {
    display: 'flex',
    width: '100%',
    paddingTop: '24px',
    paddingBottom: '18px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '16px',
      paddingBottom: '12px',
      width: '100%'
    },
  },
  customTabRoot: {
    width: '50%',
    height: '36px',
    minHeight: '36px',
    borderRadius: '3px',
    color: '#59758B',
    border: '1px solid #E5E5E5',
    fontSize: '13px',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
      fontSize: '12px',
    },
  },
  selected: {
    backgroundColor: '#005A81',
    color: '#FFFFFF',
  },
  customTabWrapper: {
    padding: 0,
  },
  tabs: {
    height: '36px',
    minHeight: '36px',
    width: '100%',
  },
  buttonRoot: {
    width: '100%',
    fontSize: '13px',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]:{
       width: '100%'
     }
  },
  unitSelectWrapper: {
    paddingTop: '30px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '20px',
    },
  },
  selectInput: {
    width: '100%',
    
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important',
  },
}));

export default useStyles;
